(function () {
  var ROOT_SELECTOR = '#dynamatic-bundle-root';
  var ITEM_SELECTOR = '._dyn_pb_productCard';
  var rootObserver = null;
  var docObserver = null;
  var pollTimer = null;
  var pollAttempts = 0;
  var MAX_POLL_ATTEMPTS = 180; // ~90s at 500ms

  function injectStylesOnce() {
    if (document.getElementById('bundle-included-pill-styles')) return;

    var style = document.createElement('style');
    style.id = 'bundle-included-pill-styles';
    style.textContent =
      ROOT_SELECTOR + ' ' + ITEM_SELECTOR + ' { position: relative; }' +
      ROOT_SELECTOR + ' .fw-included-pill {' +
      'position:absolute;top:10px;right:10px;display:inline-flex;align-items:center;gap:6px;' +
      'padding:4px 10px;border-radius:999px;background:rgba(230,43,137,0.12);color:#b80f67;' +
      'font-size:9px;font-weight:700;line-height:1;pointer-events:none;z-index:2;' +
      '}' +
      ROOT_SELECTOR + ' .fw-included-pill__icon {' +
      'width:11px;height:11px;border-radius:50%;background:#e62b89;color:#fff;display:inline-flex;' +
      'align-items:center;justify-content:center;font-size:10px;font-weight:800;' +
      '}' +
      ROOT_SELECTOR + ' ._dyn_pb_productInfo { padding-right:0 !important; min-width:0 !important; }' +
      ROOT_SELECTOR + ' ._dyn_pb_productTitle { padding-right:150px !important; margin-right:0 !important; }' +
      ROOT_SELECTOR + ' ._dyn_pb_productTitle a {' +
      'display:block !important;word-break:break-word !important;overflow-wrap:anywhere !important;' +
      '}' +
      '@media (max-width:767px){' +
      ROOT_SELECTOR + ' .fw-included-pill {top:8px;right:8px;padding:3px 8px;font-size:10px;}' +
      ROOT_SELECTOR + ' .fw-included-pill__icon {width:12px;height:12px;font-size:9px;}' +
      ROOT_SELECTOR + ' ._dyn_pb_productTitle { padding-right:135px !important; }' +
      '}';

    document.head.appendChild(style);
  }

  function addCheckmarks() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    var cards = root.querySelectorAll(ITEM_SELECTOR);
    cards.forEach(function (card) {
      if (card.querySelector('.fw-included-pill')) return;

      var pill = document.createElement('span');
      pill.className = 'fw-included-pill';
      pill.innerHTML = '<span class="fw-included-pill__icon">✓</span> Included';
      card.appendChild(pill);
    });
  }

  function attachRootObserver(root) {
    if (!root) return;
    if (rootObserver) rootObserver.disconnect();

    rootObserver = new MutationObserver(function () {
      addCheckmarks();
    });
    rootObserver.observe(root, { childList: true, subtree: true });
  }

  function startDocumentObserver() {
    if (docObserver) return;
    docObserver = new MutationObserver(function () {
      var root = document.querySelector(ROOT_SELECTOR);
      if (!root) return;
      addCheckmarks();
      attachRootObserver(root);
    });
    docObserver.observe(document.body, { childList: true, subtree: true });
  }

  function startPollingForWidget() {
    if (pollTimer) return;
    pollTimer = setInterval(function () {
      pollAttempts += 1;
      var root = document.querySelector(ROOT_SELECTOR);
      if (root) {
        addCheckmarks();
        attachRootObserver(root);
        clearInterval(pollTimer);
        pollTimer = null;
        return;
      }

      if (pollAttempts >= MAX_POLL_ATTEMPTS) {
        clearInterval(pollTimer);
        pollTimer = null;
      }
    }, 500);
  }

  function init() {
    injectStylesOnce();
    addCheckmarks();
    attachRootObserver(document.querySelector(ROOT_SELECTOR));
    startDocumentObserver();
    startPollingForWidget();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
